module.exports = __webpack_public_path__ + "img/img3.a6796f7a.png";